<app-basic-page [pageTitle]="'Leads - Invitation'" [pageDescription]="'Auto generate leads from LinkedIn'">
  <div class="vertical">
    <nz-tabset>
      <nz-tab [nzTitle]="pendingApprovalsTitle">
        <ng-template #pendingApprovalsTitle>
          <div class="horizontal no-gap">
            <span nz-icon class="material-symbols-rounded" [ngStyle]="{ marginRight: '2px' }">pause</span>
            <div>Pending Approvals ({{ pendingApprovalsLeadsList().length }})</div>
          </div>
        </ng-template>

        <div class="tab-content vertical">
          <div class="horizontal full-width" [ngStyle]="{ justifyContent: 'flex-end' }">
            <!-- <button nz-button nzType="default" nzSize="small" (click)="onApproveAllClick()">
              <span nz-icon style="font-size: 16px" class="material-symbols-rounded">done_all</span>
              Approve All
            </button> -->
            <button
              nz-button
              nzType="primary"
              nzSize="small"
              nz-dropdown
              [nzTrigger]="'click'"
              [nzDropdownMenu]="addLeadsMenu"
            >
              <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
              Add Leads
            </button>

            <nz-dropdown-menu #addLeadsMenu="nzDropdownMenu">
              <ul nz-menu>
                @for (resume of linkedInIdResumeList(); track $index) {
                  <li nz-menu-item (click)="onAddLeadsClick(resume)">
                    <app-profile-card-small [resume]="resume"></app-profile-card-small>
                  </li>
                }
              </ul>
            </nz-dropdown-menu>
          </div>

          <nz-table
            class="full-width"
            #leadsTable
            [nzData]="pendingApprovalsLeadsList()"
            [nzPaginationType]="'small'"
            [nzPageSize]="30"
          >
            <thead>
              <tr>
                <th>Id</th>
                <th [nzWidth]="'300px'">User</th>
                <th [nzWidth]="'150px'">LinkedIn</th>
                <th>Product</th>
                <th>Connect Message</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (data of leadsTable.data; track data.id; let i = $index) {
                <tr>
                  <td>
                    <app-copy-button [text]="data.id"></app-copy-button>
                  </td>
                  <td>
                    <app-profile-card-small
                      [resume]="getResume(data.unsafeSubData.resumeId)()"
                    ></app-profile-card-small>
                  </td>
                  <td>
                    <a
                      [href]="getResume(data.unsafeSubData.resumeId)()?.subData?.url"
                      nz-button
                      nzType="link"
                      nzSize="small"
                      target="_blank"
                    >
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">open_in_new</span>
                      LinkedIn
                    </a>
                  </td>
                  <td>
                    <nz-select class="select" [nzSize]="'small'" [(ngModel)]="data.unsafeSubData.productId">
                      @for (item of productList(); track $index) {
                        <nz-option [nzValue]="item.id" [nzLabel]="item.title ?? ''"></nz-option>
                      }
                    </nz-select>
                  </td>
                  <td>
                    {{ data.unsafeSubData.inviteMessage }}
                    <div class="vertical center buttons">
                      @if ((data.unsafeSubData.inviteMessage ?? '').length <= charsLimit()) {
                        <nz-tag [ngStyle]="{ height: '21px' }">
                          Total Chars: {{ data.unsafeSubData.inviteMessage?.length }}
                        </nz-tag>
                      } @else {
                        <nz-tag nzColor="error" [ngStyle]="{ height: '21px' }">
                          <span nz-icon nzType="close-circle"></span>
                          <span>
                            Total chars must be fewer than {{ charsLimit() }} [Currently:
                            {{ data.unsafeSubData.inviteMessage?.length }}].
                          </span>
                        </nz-tag>
                      }
                      <app-popover-edit-text
                        [buttonType]="'default'"
                        [content]="data.unsafeSubData.inviteMessage"
                        (saveChange)="onSaveInviteMessageClick(data, $event)"
                      ></app-popover-edit-text>

                      <button nz-button nzType="default" nzSize="small" (click)="onRegenerateMessageClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
                        Regenerate
                      </button>
                    </div>
                  </td>
                  <td>
                    <div class="vertical">
                      @if (getResume(data.unsafeSubData.resumeId)()?.subData?.linkedInProviderId) {
                        <button
                          nz-button
                          nzType="default"
                          nzSize="small"
                          [disabled]="(data.unsafeSubData.inviteMessage ?? '').length > charsLimit()"
                          (click)="onApproveLeadsClick(data)"
                        >
                          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">check</span>
                          Approve
                        </button>
                      } @else {
                        <button
                          nz-button
                          nzType="default"
                          [disabled]="true"
                          nzSize="small"
                          (click)="onGetLinkedInProviderIdClick()"
                        >
                          <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
                          Get LinkedIn Provider Id
                        </button>
                      }
                      <button nz-button nzType="default" nzSize="small" (click)="onDeleteLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>
        </div>
      </nz-tab>
      <nz-tab [nzTitle]="processingQueueTitle">
        <ng-template #processingQueueTitle>
          <div class="horizontal no-gap">
            <span nz-icon class="material-symbols-rounded" [ngStyle]="{ marginRight: '2px' }">play_arrow</span>
            <div>Processing Queue ({{ processingQueueLeadsList().length }})</div>
          </div>
        </ng-template>

        <div class="tab-content">
          <nz-table
            class="full-width"
            #processingQueueLeadsTable
            [nzData]="processingQueueLeadsList()"
            [nzPaginationType]="'small'"
            [nzPageSize]="30"
          >
            <thead>
              <tr>
                <th>Id</th>
                <th [nzWidth]="'300px'">User</th>
                <th [nzWidth]="'150px'">LinkedIn</th>
                <th>Product</th>
                <th>Connect Message</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (data of processingQueueLeadsTable.data; track data.id; let i = $index) {
                <tr>
                  <td>
                    <app-copy-button [text]="data.id"></app-copy-button>
                  </td>
                  <td>
                    <app-profile-card-small
                      [resume]="getResume(data.unsafeSubData.resumeId)()"
                    ></app-profile-card-small>
                  </td>
                  <td>
                    <a
                      [href]="getResume(data.unsafeSubData.resumeId)()?.subData?.url"
                      nz-button
                      nzType="link"
                      nzSize="small"
                      target="_blank"
                    >
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">open_in_new</span>
                      LinkedIn
                    </a>
                  </td>
                  <td>
                    {{ getProduct(data.unsafeSubData.productId)()?.title }}
                  </td>
                  <td>
                    {{ data.unsafeSubData.inviteMessage }}
                    <div class="vertical buttons">
                      <app-popover-edit-text
                        [content]="data.unsafeSubData.inviteMessage"
                        (saveChange)="onSaveInviteMessageClick(data, $event)"
                      ></app-popover-edit-text>

                      <button nz-button nzType="default" nzSize="small" (click)="onRegenerateMessageClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
                        Regenerate
                      </button>
                    </div>
                  </td>
                  <td>
                    {{ getLastWordFromCamelCase(data.status) }}
                  </td>
                  <td>
                    <div class="vertical">
                      <button nz-button nzType="default" nzSize="small" (click)="onSendInvitationClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">mail</span>
                        Invite Now
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onMarkAsDoneClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">check</span>
                        Mark as Done
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onDeleteLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>
        </div>
      </nz-tab>
      <nz-tab [nzTitle]="invitePendingTitle">
        <ng-template #invitePendingTitle>
          <div class="horizontal no-gap">
            <span nz-icon class="material-symbols-rounded" style="font-size: 20px" [ngStyle]="{ marginRight: '2px' }"
              >hourglass_empty</span
            >
            <div>Awaiting Connection ({{ invitePendingList().length }})</div>
          </div>
        </ng-template>

        <div class="tab-content">
          <nz-table
            class="full-width"
            #invitePendingTable
            [nzData]="invitePendingList()"
            [nzPaginationType]="'small'"
            [nzPageSize]="30"
          >
            <thead>
              <tr>
                <th>Id</th>
                <th [nzWidth]="'300px'">User</th>
                <th [nzWidth]="'150px'">LinkedIn</th>
                <th>Product</th>
                <th>Connect Message</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (data of invitePendingTable.data; track data.id; let i = $index) {
                <tr>
                  <td>
                    <app-copy-button [text]="data.id"></app-copy-button>
                  </td>
                  <td>
                    <app-profile-card-small
                      [resume]="getResume(data.unsafeSubData.resumeId)()"
                    ></app-profile-card-small>
                  </td>
                  <td>
                    <a
                      [href]="getResume(data.unsafeSubData.resumeId)()?.subData?.url"
                      nz-button
                      nzType="link"
                      nzSize="small"
                      target="_blank"
                    >
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">open_in_new</span>
                      LinkedIn
                    </a>
                  </td>
                  <td>
                    {{ getProduct(data.unsafeSubData.productId)()?.title }}
                  </td>
                  <td>
                    {{ data.unsafeSubData.inviteMessage }}
                    <div class="vertical buttons">
                      <app-popover-edit-text
                        [buttonType]="'default'"
                        [content]="data.unsafeSubData.inviteMessage"
                        (saveChange)="onSaveInviteMessageClick(data, $event)"
                      ></app-popover-edit-text>

                      <button nz-button nzType="default" nzSize="small" (click)="onRegenerateMessageClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
                        Regenerate
                      </button>
                    </div>
                  </td>
                  <td>
                    {{ getLastWordFromCamelCase(data.status) }}
                  </td>
                  <td>
                    <div class="vertical">
                      <button nz-button nzType="default" nzSize="small" (click)="onApproveLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
                        Retry
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onMarkAsDoneClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">check</span>
                        Mark as Done
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onDeleteLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>
        </div>
      </nz-tab>
      <nz-tab [nzTitle]="failedInvitationTitle">
        <ng-template #failedInvitationTitle>
          <div class="horizontal no-gap">
            <span nz-icon class="material-symbols-rounded" style="font-size: 20px" [ngStyle]="{ marginRight: '2px' }"
              >error</span
            >
            <div>Failed Invitation ({{ failedInvitationList().length }})</div>
          </div>
        </ng-template>

        <div class="tab-content">
          <nz-table
            class="full-width"
            #failedInvitationTable
            [nzData]="failedInvitationList()"
            [nzPaginationType]="'small'"
            [nzPageSize]="30"
          >
            <thead>
              <tr>
                <th>Id</th>
                <th [nzWidth]="'300px'">User</th>
                <th [nzWidth]="'150px'">LinkedIn</th>
                <th>Product</th>
                <th>Connect Message</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (data of failedInvitationTable.data; track data.id; let i = $index) {
                <tr>
                  <td>
                    <app-copy-button [text]="data.id"></app-copy-button>
                  </td>
                  <td>
                    <app-profile-card-small
                      [resume]="getResume(data.unsafeSubData.resumeId)()"
                    ></app-profile-card-small>
                  </td>
                  <td>
                    <a
                      [href]="getResume(data.unsafeSubData.resumeId)()?.subData?.url"
                      nz-button
                      nzType="link"
                      nzSize="small"
                      target="_blank"
                    >
                      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">open_in_new</span>
                      LinkedIn
                    </a>
                  </td>
                  <td>
                    {{ getProduct(data.unsafeSubData.productId)()?.title }}
                  </td>
                  <td>
                    {{ data.unsafeSubData.inviteMessage }}
                    <div class="vertical buttons">
                      <app-popover-edit-text
                        [buttonType]="'default'"
                        [content]="data.unsafeSubData.inviteMessage"
                        (saveChange)="onSaveInviteMessageClick(data, $event)"
                      ></app-popover-edit-text>

                      <button nz-button nzType="default" nzSize="small" (click)="onRegenerateMessageClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
                        Regenerate
                      </button>
                    </div>
                  </td>
                  <td>
                    <div>{{ getLastWordFromCamelCase(data.status) }}</div>
                    <div>{{ data.statusMessage }}</div>
                  </td>
                  <td>
                    <div class="vertical">
                      <button nz-button nzType="default" nzSize="small" (click)="onApproveLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">refresh</span>
                        Retry
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onMarkAsDoneClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">check</span>
                        Mark as Done
                      </button>
                      <button nz-button nzType="default" nzSize="small" (click)="onDeleteLeadsClick(data)">
                        <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </nz-table>
        </div>
      </nz-tab>
    </nz-tabset>
  </div>
</app-basic-page>
